var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.app,attrs:{"id":"app"}},[_c('el-container',[(_vm.isAuthenticated)?_c('header-component'):_vm._e()],1),_c('el-container',{staticStyle:{"min-height":"100vh"}},[_c('router-view')],1),_c('el-container',[(_vm.isAuthenticated)?_c('footer-component'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5abd4551","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/masteradmin/App.vue
// module id = fLDS
// module chunks = 1